export default __webpack_public_path__ + "static/media/rank-chart-icon.c9a862f7.svg";